export default {
	drawer: null,
	color: 'light-blue darken-1',
	image: 'https://demos.creative-tim.com/vue-material-dashboard/img/sidebar-2.32103624.jpg',
	alert: {
		status: false,
		text: '',
		type: 'success'
	},
	// prevUrl: '',
};